var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"broker360-pet-app",style:({'--accent-color': _vm.customColor}),attrs:{"id":"broker360-pet-app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }